export default __webpack_public_path__ + "static/media/LilNounsReadingSharkDAO.dce936c3.png";